import { VerifiedBadge } from "../components/VerifiedBadge";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Navbar";
import { Avatar } from "../components/Posts";
import { api } from "../api";
import { orgTypeLabel } from "../lib/orgTypes";

export default function Organizations() {
  const { t } = useTranslation();
  const [orgs, setOrgs] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/organizations", { params: { q } }).then(({data}) => setOrgs(data)); }, [q]);
  return (<Layout><div className="yp-container py-8">
    <h1 className="text-3xl font-bold mb-4">{t("nav.organizations")}</h1>
    <input className="yp-input mb-6 max-w-md" placeholder={t("common.search")} value={q} onChange={e=>setQ(e.target.value)} data-testid="org-search" />
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
      {orgs.length === 0 && <div className="col-span-full text-center text-slate-400 py-12" data-testid="organizations-empty">{t("common.empty")}</div>}
      {orgs.map(o => (
        <Link key={o.id} to={`/organizations/${o.id}`} className="yp-card p-5 block" data-testid="org-card">
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center gap-2">
              <Avatar url={o.avatar_url} label={o.org_name} org cls="w-10 h-10" />
              <div className="font-semibold flex items-center gap-1">{o.org_name}{o.verified && <VerifiedBadge size={15} />}</div>
            </div>
          </div>
          {orgTypeLabel(o.org_type, t, o.org_type_other) && <div className="text-sm font-medium text-blue-700" data-testid="org-card-type">{orgTypeLabel(o.org_type, t, o.org_type_other)}</div>}
          <div className="text-sm text-slate-600 mt-2">📍 {o.city || "—"}{o.country ? ` · ${o.country}` : ""}</div>
          {o.phone && <div className="text-sm text-slate-600 mt-1">📞 {o.phone}</div>}
        </Link>))}
    </div>
  </div></Layout>);
}
